<template>
  <div>
    <div class="studentsProgress headerButtons">
      <div class="studentsProgress headerButtons__backButton">
        <b-button variant="outline-primary" @click="$router.back()" class="mt-2">
            Назад
        </b-button>
      </div>
    </div>
    <div class="studentsProgress">
      <!-- Заголовок -->
      <div class="studentsProgress__title mt-2 d-flex justify-content-between flex-wrap">
        <h3>
          <em class="fas fa-tasks"></em>
          Прогресс по курсу
        </h3>
        <div class="ml-auto text-right">
          <b-button
            class="mb-2 ml-2"
            variant="primary"
            title="Экспорт для выбранной организации"
            @click="exportProgress">
            <em class="fas fa-file-excel mr-1"></em> Экспорт для выбранной
          </b-button>
          <b-button
            v-if="hasRole('curator')"
            variant="primary"
            class="mb-2 ml-2"
            title="Экспорт для всех организаций"
            @click="exportProgressAll">
            <em class="fas fa-file-excel mr-1"></em> Экспорт для всех
          </b-button>
        </div>
      </div>
    </div>
    <!-- Фильтры -->
    <div class="studentsProgress__filters mb-2">
      <b-form-select
        v-model="selectedOrg"
        :options="optionsOrg"
        v-b-tooltip.hover
        title="Организация"
        class="mt-2 studentsProgress__filters-organisation"
        @change="onFiltersChange"
      >
      </b-form-select>
      <b-form-select
        v-model="selectedClass"
        :options="optionsClass"
        v-b-tooltip.hover
        title="Класс"
        class="mt-2 studentsProgress__filters-class"
        @change="onFiltersChange"
      >
      </b-form-select>
    </div>
    <!-- Таблица -->
    <div class="studentsProgress__table mt-1" ref="studentsProgressGridDiv">
      <ag-grid-vue
        style="width: 100%; height: 100%;"
        class="ag-theme-material ag-grid-vue-progress"
        rowHeight="50"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :rowData="studentsProgress"
        :suppressPaginationPanel="true"
        :frameworkComponents="frameworkComponents"
        :context="context"
        @grid-ready="onGridReady"
        @gridSizeChanged="onGridSizeChanged"
      >
      </ag-grid-vue>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'

import { mapActions, mapGetters } from 'vuex'

import ProgressRenderer from '@/components/helpers/renderers/ProgressRenderer'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'
import EducationAPI from '@/api/education'

export default {
  name: 'CourseStudentsProgress',
  components: {
    'ag-grid-vue': AgGridVue
  },
  props: {
    editMode: Boolean
  },
  data() {
    return {
      optionsClass: [
        { value: ['10', '11'], text: 'Все классы' },
        { value: ['10'], text: '10 класс' },
        { value: ['11'], text: '11 класс' }
      ],
      selectedOrg: null,
      selectedClass: ['10', '11'],
      frameworkComponents: {
        progressRenderer: ProgressRenderer
      },
      columnDefs: [
        {
          headerName: 'Фамилия',
          field: 'surname',
          sortable: true,
          headerClass: 'ag-grid-table-header'
        },
        {
          headerName: 'Имя',
          field: 'name',
          sortable: true,
          headerClass: 'ag-grid-table-header'
        },
        {
          headerName: 'Отчество',
          field: 'midname',
          sortable: true,
          headerClass: 'ag-grid-table-header'
        },
        {
          headerName: 'Решено',
          field: 'solved',
          sortable: true,
          headerClass: 'ag-grid-table-header',
          valueFormatter: this.solvedFormatter,
          valueGetter: this.progressGetter
        },
        {
          headerName: '',
          field: 'progress',
          sortable: false,
          headerClass: 'ag-grid-table-header',
          cellRenderer: 'progressRenderer',
          width: 250,
          suppressSizeToFit: true,
          valueFormatter: this.progressFormatter,
          valueGetter: this.progressGetter
        }
      ],
      gridApi: null,
      columnApi: null,
      autoGroupColumnDef: null,
      gridOptions: {
        defaultColDef: {
          autoHeight: false
        },
        localeText: AG_GRID_LOCALE_RU,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      context: {
        componentParent: this
      },
      rowGroupPanelShow: null,
      pivotPanelShow: null
    }
  },
  computed: {
    ...mapGetters({
      currUser: 'currentUser/getCurrentUser',
      hasRole: 'currentUser/hasRole',
      orgs: 'dicts/getOrganizations',
      studentsProgress: 'educationStudentsManagement/getStudentsProgress',
      courseContent: 'education/getCourseContent',
      courseSubsectionsStructure: 'education/getCourseSubsectionsStructure',
      test: 'test/getTest'
    }),
    // получаем организации, доступные пользователю (в которых он состоит)
    optionsOrg() {
      if (this.orgs && this.orgs.length) {
        if (this.hasRole('curator')) {
          return this.orgs
            .filter((org) => org.type === 'ГП-класс' || org.type === 'СПО')
            .sort((org1, org2) => (org1.text > org2.text ? 1 : -1))
            .map((org) => ({
              value: org.id,
              text: org.title
            }))
        }
        if (this.hasRole('classroom-teacher')) {
          return [{
            value: this.currUser.organizationId,
            text: this.orgs.filter((p) => p.id === this.currUser.organizationId)[0].title
          }]
        }
      }
      return []
    }
  },
  created() {
    if (!this.courseContent) {
      this.fetchCourseContent({
        id: this.$route.params.courseBookId,
        all: false
      })
    }
    this.selectedOrg = this.orgs.filter((p) => p.id === this.currUser.organizationId)[0].id
    if (!this.optionsOrg.find((option) => option.value === this.selectedOrg)) {
      this.selectedOrg = this.optionsOrg.length ? this.optionsOrg[0].value : null
    }
    if (this.selectedOrg) {
      this.fetchStudentsProgress({
        courseId: this.$route.params.courseBookId,
        classes: this.selectedClass,
        organizationId: this.selectedOrg
      })
    }
  },
  methods: {
    getProgressLength(courses, structure) {
      let solved = 0
      if (courses.length > 0) {
        solved = Object
          .entries(courses[0].progress)
          .filter((p) => structure.tasks.includes(Number(p[0])))
          .filter((p) => p[1] === true).length
      }
      return solved
    },
    solvedFormatter(params) {
      const structure = this.courseSubsectionsStructure
      const solved = this.getProgressLength(params.data.userCourses, structure)
      return `${solved > 0 ? solved : '-'} / ${structure.tasks.length}`
    },
    progressGetter(params) {
      return this.getProgressLength(params.data.userCourses, this.courseSubsectionsStructure)
    },
    progressFormatter(params) {
      const structure = this.courseSubsectionsStructure
      const solved = this.getProgressLength(params.data.userCourses, structure)
      return structure.tasks.length > 0
        // eslint-disable-next-line no-mixed-operators
        ? Number(solved / structure.tasks.length * 100)
        : 0
    },
    ...mapActions({
      fetchStudentsProgress: 'educationStudentsManagement/fetchCourseStudentsProgress',
      fetchCourseContent: 'education/fetchCourseContent',
      fetchTest: 'test/fetchTest'
    }),
    exportProgress() {
      EducationAPI.exportStudentProgressExcel(this.$route.params.courseBookId, this.selectedClass, this.selectedOrg)
    },
    exportProgressAll() {
      EducationAPI.exportStudentProgressExcel(this.$route.params.courseBookId, this.selectedClass, 'all')
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      if (this.$refs.studentsProgressGridDiv.clientWidth >= 1300) {
        this.gridApi.sizeColumnsToFit()
      }
      this.gridWidth = this.$refs.studentsProgressGridDiv.clientWidth
    },
    onGridSizeChanged() {
      if ((this.$refs.studentsProgressGridDiv.clientWidth >= 1300
            && this.$refs.studentsProgressGridDiv.clientWidth > this.gridWidth)
            || (this.$refs.studentsProgressGridDiv.clientWidth >= 1500)) {
        this.gridApi.sizeColumnsToFit()
      }
      this.gridWidth = this.$refs.studentsProgressGridDiv.clientWidth
    },
    onFiltersChange() {
      this.fetchStudentsProgress({
        courseId: this.$route.params.courseBookId,
        classes: this.selectedClass,
        organizationId: this.selectedOrg
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.ag-header-cell-label {
  justify-content: center;
}
.ag-row .ag-cell {
  display: inline-flex;
  align-items: center;
  font-size: 15px;
  justify-content: center;
  text-align: center;
  white-space: normal;
  line-height: 1.4em !important;
}
.ag-grid-table-header {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-weight: bold;
}
.ag-row .ag-cell{
  padding: 0 !important;
}
.ag-header-cell-label {
  justify-content: center;
}
.studentsProgress__table.ag-row .ag-cell {
  display: flex;
  align-items: center;
  font-size: 15px;
  justify-content: center;
  text-align: center;
  white-space: normal;
  line-height: 1.4em;
}
.students-table-header {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-weight: bold;
}
.studentsProgress__table.ag-row .ag-cell {
  padding: 0 !important;
}

.studentsProgress {

  &__filters {
    width: 100%;

    &-organisation {
      width: 78%;
    }

    &-class {
      float: right;
      width: 20%;
    }
  }

  &__table {
    height: calc(100vh - 270px);
    border-bottom: 1px solid lightgray;
  }

  &__paginator {
    position: relative !important;
    text-align: right !important;
  }

}

</style>
